module.exports = __webpack_public_path__ + "img/open-15_12month01.8cdb7e10.png";